import React from "react";
import styled from "styled-components";
import { useField } from "formik";
import icons from "./../../../assets/icon-image.png";
import FormError from "../FormError/FormError";

const Checkbox = ({ children, ...props }) => {
  const [field, meta] = useField({ ...props, type: "checkbox" });

  return (
    <>
      <InputWrapper>
        <input type="checkbox" {...field} {...props} id={props.name} />
        <Label htmlFor={props.name}>{children}</Label>
        {meta.touched && meta.error ? <FormError text={meta.error} /> : null}
      </InputWrapper>
    </>
  );
};

export default Checkbox;

const InputWrapper = styled.div`
  input[type="checkbox"] {
    display: none;
  }

  input[type="checkbox"]:checked + label:after {
    width: 16px;
    height: 16px;
    background: url(${icons}) no-repeat -19px -137px;
    position: absolute;
    top: 4px;
    left: -24px;
    z-index: 10;
    content: "";
    display: inline-block;
  }
`;

const Label = styled.label`
  margin-left: 25px;
  width: 100%;
  position: relative;
  margin-top: 10px;
  font-size: 14px;

  &:before {
    position: absolute;
    top: 4px;
    left: -24px;
    content: "";
    display: inline-block;
    width: 16px;
    height: 16px;
    z-index: 5;
    border: 1px solid #e3e1e1;
    background-color: #f7f7f7;
    border-radius: 3px;
  }

  &:hover {
    cursor: pointer;
  }
`;
